import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { RouterModule } from '@angular/router';
import { GlobalVariableService } from "../app/core/common/variables/global-variable";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule
  ],
  providers: [GlobalVariableService,
    {
      provide: APP_INITIALIZER,
      useFactory: (global: GlobalVariableService) => global.loadLngData(localStorage.getItem('lng') ? localStorage.getItem('lng') : global.enString),
      deps: [GlobalVariableService],
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
